import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FormFieldBase} from '../form-field-base';
import {FormFieldService} from '../form-field.service';
import {FormDataModel} from '../form-data.model';
import {takeUntil} from 'rxjs/operators';
import {Subject, Subscription} from 'rxjs';

@Component({
  selector: 'qm-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent implements OnInit, OnChanges, OnDestroy {

  @Input() fields: FormFieldBase<any>[] = [];
  @Input() formName: string;
  @Input() horizontal: boolean = false;
  @Input() titleWidth: number = 3;
  @Input() dataWidth: number = 9;
  @Output() formData: EventEmitter<any> = new EventEmitter();
  @Output() formSubmit: EventEmitter<any> = new EventEmitter();
  form: FormGroup;
  payLoad = '';
  /**
   * Subscription manager
   * @type {Subject<any>}
   */
  private ngUnsubscribe: Subject<boolean> = new Subject();
  private sub: Subscription;

  constructor(private fieldService: FormFieldService) {
  }

  ngOnInit(): void {
    // this.form = this.fieldService.toFormGroup(this.fields);
    console.log(this.fields);
    console.log(this.form);
    /*
    this.form.valueChanges.subscribe((data) => {
      console.log('FORM CHANGED');
      console.log(data);
    });
    */
  }

  ngOnChanges(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.form = this.fieldService.toFormGroup(this.fields);
    // console.log(this.fields);
    // console.log(this.form);
    this.sub = this.form.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data) => {
      this.formData.emit(data);
      console.log('FORM CHANGED');
      console.log(data);
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onSubmit() {
    this.payLoad = JSON.stringify(this.form.value);
    const data = new FormDataModel();
    data.formName = this.formName;
    data.payload = this.form.value;
    console.log(data);
    console.log(this.fields);
    console.log(this.form);
    this.formSubmit.emit(this.form.value);
    // this.formDataService.create(data);
  }

}
